module.exports = __webpack_public_path__ + "img/rockweels_planners.497364e9.jpg";